"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenObject = void 0;

var _stringUtils = require("@eb/string-utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Recursively transform nested objects into a single flat object with combined
 * keys. {root: {nested: 'value'}} becomes {rootNested: 'value'}
 */
var flattenObject = function flattenObject(obj) {
  var object = obj;
  /* eslint-disable guard-for-in */

  for (var key in object) {
    var originalValue = object[key];

    if (_typeof(originalValue) !== 'object' || originalValue === null || !object.hasOwnProperty(key)) {
      continue;
    } // for multi-level flattening


    var flattenedValue = flattenObject(originalValue);

    for (var nestedKey in flattenedValue) {
      if (!flattenedValue.hasOwnProperty(nestedKey)) {
        continue;
      }

      object[(0, _stringUtils.snakeToCamel)("".concat(key, "_").concat(nestedKey))] = flattenedValue[nestedKey];
    }

    delete object[key];
  }

  return object;
};

exports.flattenObject = flattenObject;
//# sourceMappingURL=flattenObject.js.map